import React from 'react';
import { SecureRoute } from '@okta/okta-react';
import { connect } from 'react-redux';
/* eslint-disable import/no-cycle */
import accountRoutes from '../../app/router/accountRoutes';

import { getCurrentAllotments, getFutureAllotments } from '../../gamedayAccount/selectors';

const Allotments = props => (
  <div>
    {accountRoutes
      .find(route => route.path === '/account/allotments')
      .routes.map(subRoute => {
        // eslint-disable-next-line react/destructuring-assignment
        const allotmentData = props[subRoute.disableWhenEmpty];
        const isEmpty = !allotmentData || Object.keys(allotmentData).length === 0;

        return (
          <SecureRoute
            key={subRoute.path}
            path={subRoute.path}
            exact={subRoute.exact}
            component={subRoute.component}
            disable={subRoute.disableWhenEmpty && isEmpty}
          />
        );
      })}
  </div>
);

const mapStateToProps = state => ({
  currentAllotments: getCurrentAllotments(state),
  futureAllotments: getFutureAllotments(state, true)
});

const connector = connect(mapStateToProps, {});

export default connector(Allotments);
